var $a3b7c6b15e2b7baa$exports = {};
$a3b7c6b15e2b7baa$exports = {
    "actions": `Handlinger`,
    "hideButtonLabel": `Vis mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};


export {$a3b7c6b15e2b7baa$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
